import { z } from "zod";

export const updateSivDataCarIconStatusPayloadSchema = z.object({
  uuid: z.uuid(),
  status: z.enum(["VALIDATED", "REJECTED"]),
  updatedBy: z.string(),
});

export type UpdateSivDataCarIconStatusPayload = z.infer<
  typeof updateSivDataCarIconStatusPayloadSchema
>;
